<mat-accordion>
  <mat-expansion-panel class="expansion-panel" [expanded]="step === 0" (opened)="setStep(0)">
    <mat-progress-bar *ngIf="loadTipoDocs" class="progress-bar" mode="indeterminate"></mat-progress-bar>
    <p>
      <label class="mat-h2">Selecione o tipo de Documento: </label>
    </p>

    <br />
    <mat-expansion-panel-header class="custom-header">
      <mat-panel-title>
        1. Tipo de Documento: {{tipoDocSelected.tipoDocumento}}
      </mat-panel-title>
    </mat-expansion-panel-header>

    <form [formGroup]="tipoDocumentoForm">
      <div class="container" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%" fxLayoutAlign="center">
        <div>
          <div class="container" fxLayout="row">
            <mat-card fxFlex="100%" class="mat-elevation-z0 ">
              <img mat-card-image class="img img-small-max-width" src="../../../assets/images/imgNaoFiscal.PNG"
                alt="Imagem Código de Barras">
              <mat-card-content class="card-content-text">
                <h2>Não Fiscal</h2>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="container" fxLayout="row">
            <mat-form-field style="width:100%">

              <mat-select formControlName="frmTipoDoc" [(ngModel)]="tipoDocSelected"
                placeholder="Qual o tipo do Não Fiscal" (selectionChange)="VerificarAdiantamentoNaoFiscal()" required>
                <mat-option *ngFor="let tipoDoc of tipoDocs" [value]="tipoDoc">
                  {{tipoDoc.tipoDocumento}}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="fTpDoc.frmTipoDoc.errors && fTpDoc.frmTipoDoc.errors.required">{{getErrorMessage()}}</mat-error>
            </mat-form-field>
          </div>
          <div class="container" fxLayout="row">
            <form class="dropzone needsclick" id="demo-upload" action="/upload">
              <div class="dz-message needsclick upload text-center">
                <app-upload></app-upload>
                <br />
              </div>
            </form>
          </div>
          <div fxLayout="row">
            <mat-error *ngIf="fileUploadLenth && LstUploadFiles.length == 0 ">Necessário pelo menos um
              arquivo</mat-error>
          </div>
        </div>

      </div>
      <div class="lista-upload">
        <mat-chip-list>
          <mat-chip class="pointer" *ngFor="let doc of LstUploadFiles" (click)="downloadImage(doc)">
            {{doc}}
            <mat-icon class="check">check</mat-icon>
            <mat-icon (click)="deleteFile(doc)" class="delete-file">delete</mat-icon>
          </mat-chip>
        </mat-chip-list>
      </div>
      <br />
      <mat-action-row class="footer">
        <button id="btnTipoDoc" mat-button color="primary" class="btn-primary"
          (click)="onSubmitTipoDoc()">CONTINUAR</button>
      </mat-action-row>
    </form>
  </mat-expansion-panel>

  <mat-expansion-panel *ngIf="fv60" class="expansion-panel" [disabled]="formulario2Disbled" [expanded]="step === 1"
    (opened)="setStep(1)">

    <mat-expansion-panel-header class="custom-header">
      <mat-panel-title>
        2. Ficha do Protocolo
      </mat-panel-title>
    </mat-expansion-panel-header>

    <mat-progress-bar *ngIf="loadCNPJs" class="progress-bar" mode="indeterminate"></mat-progress-bar>
    <form [formGroup]="cabecalhoForm">
      <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
        <mat-form-field>
          <input matInput formControlName="frmCnpjEmpresa" [(ngModel)]="cabecalhoProtocolo.cnpjEmpresa"
            (input)="formatarCNPJEmpresaInput($event)" (blur)="carregarEmpresaTomador()"
            placeholder="CNPJ DA EMPRESA MRV" required maxlength="18" pattern="[A-Za-z0-9./-]*">
          <mat-error
            *ngIf="f.frmCnpjEmpresa.errors && f.frmCnpjEmpresa.errors.required">{{getErrorCNPJMessage()}}</mat-error>
        </mat-form-field>

        <mat-form-field>
          <input matInput formControlName="frmNomeEmpresa" [(ngModel)]="cabecalhoProtocolo.nomeEmpresa"
            value="{{empresaMRV.descricaoEmp}}" placeholder="NOME DA EMPRESA MRV">
          <mat-error *ngIf="f.frmNomeEmpresa.errors && f.frmNomeEmpresa.errors.required">Nome da empresa deve ser
            preenchido
          </mat-error>
        </mat-form-field>
        <mat-form-field class="example-full-width">
          <input formControlName="frmAprovador" type="text" placeholder="APROVADOR" aria-label="Number" matInput
            [formControl]="frmAprovador" [(ngModel)]="cabecalhoProtocolo.aprovador"
            [(value)]="cabecalhoProtocolo.aprovador" [matAutocomplete]="autoAprovador" required>
          <mat-autocomplete #autoAprovador="matAutocomplete">
            <mat-option *ngFor="let option of filteredOptionsAprovador | async" [value]="option">
              {{option}}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="f.frmAprovador.errors && f.frmAprovador.errors.required">Um aprovador válido deve ser
            selecionado</mat-error>
          <mat-hint *ngIf="carregandoAprovador">Carregando aprovadores, aguarde finalizar <img alt="Imagem load"
              src="assets/images/load32.gif" /></mat-hint>
        </mat-form-field>
      </div>
      <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
        <mat-form-field>
          <input matInput formControlName="frmCnpjFornecedor" [(ngModel)]="cabecalhoProtocolo.cnpjFornecedor"
            (change)="carregarFornecedor()" placeholder="CNPJ/CPF/CÓDIGO DO FORNECEDOR" maxlength="20" required>
          <mat-error
            *ngIf="f.frmCnpjFornecedor.errors && f.frmCnpjFornecedor.errors.required">{{getErrorCNPJMessage()}}</mat-error>
        </mat-form-field>

        <mat-form-field>
          <input matInput formControlName="frmNomeFornecedor" placeholder="NOME FORNECEDOR"
            [(ngModel)]="cabecalhoProtocolo.nomeFornecedor" value="{{fornecedor.nomeFornecedor}}">
          <mat-error *ngIf="f.frmNomeFornecedor.errors && f.frmNomeFornecedor.errors.required">Nome do fornecedor deve
            ser preenchido</mat-error>
        </mat-form-field>
        <mat-form-field>
          <input matInput placeholder="VALOR" formControlName="frmValor" [(ngModel)]="cabecalhoProtocolo.valor"
            class="example-right-align" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
          <mat-error *ngIf="f.frmValor.errors && f.frmValor.errors.required">Valor deve ser preenchido</mat-error>
        </mat-form-field>
        <mat-form-field class="example-full-width">
          <input formControlName="frmDivisao" type="text" placeholder="DIVISÃO" aria-label="Number" matInput
            [formControl]="frmDivisao" [(ngModel)]="cabecalhoProtocolo.divisao" [(value)]="cabecalhoProtocolo.divisao"
            [matAutocomplete]="autoDivisao" required>
          <mat-autocomplete #autoDivisao="matAutocomplete">
            <mat-option *ngFor="let option of filteredOptionsDivisao | async" [value]="option">
              {{option}}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="f.frmDivisao.errors && f.frmDivisao.errors.required">Uma divisão válida deve ser
            selecionada</mat-error>
          <mat-hint *ngIf="carregandoDivisao">Carregando divisão, aguarde finalizar <img alt="Imagem load"
              src="assets/images/load32.gif" /></mat-hint>
        </mat-form-field>
      </div>
      <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
        <mat-form-field>
          <input matInput formControlName="frmDtEmissao" [matDatepickerFilter]="filterDataEmissao"
            (click)="picker.open()" [(ngModel)]="cabecalhoProtocolo.emissao" [matDatepicker]="picker"
            placeholder="EMISSÃO" readonly>
          <span matSuffix class="calendar">
            <mat-icon (click)="picker.open()">calendar_today</mat-icon>
          </span>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error *ngIf="f.frmDtEmissao.errors && f.frmDtEmissao.errors.required">A data de emissão é
            obrigatória</mat-error>
        </mat-form-field>
        <section class="slide-toggle">
          <mat-slide-toggle formControlName="frmParcelado" name="slideParcelado" [checked]="parcelado"
            (change)="VerificaParcelado()">PARCELADO</mat-slide-toggle>
        </section>
        <div>
          <mat-form-field>
            <mat-select formControlName="frmCondicaoPag" id="condicaoPagamento"
              [(ngModel)]="cabecalhoProtocolo.codigoParametro" [(value)]="cabecalhoProtocolo.codigoParametro"
              placeholder="CONDIÇÃO DE PAGAMENTO">
              <mat-option *ngFor="let condicaoPg of condicoesPagamento" [value]="condicaoPg.valor">
                {{condicaoPg.nome}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="!parcelado">Uma condição de pagamento deve ser selecionada se a opção 'Parcelado' estiver
              marcado
            </mat-error>
          </mat-form-field>
        </div>
        <mat-form-field>
          <input matInput [matDatepicker]="picker1" [max]="maxDate" (change)="validarDataVencimento($event)"
            (dateChange)="validarDataVencimento($event)" (click)="picker1.open()"
            formControlName="frmPrimeiroVencimento" [(ngModel)]="cabecalhoProtocolo.primeiroVencimento"
            placeholder="Primeiro vencimento" readonly>
          <span matSuffix class="calendar">
            <mat-icon (click)="picker1.open()">calendar_today</mat-icon>
          </span>
          <mat-datepicker #picker1></mat-datepicker>
          <mat-error *ngIf="f.frmPrimeiroVencimento.errors && f.frmPrimeiroVencimento.errors.required">A data de
            vencimento é obrigatória</mat-error>
        </mat-form-field>
      </div>
      <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
        <mat-form-field fxFlex="30%">
          <input matInput placeholder="DESCRIÇÃO DA NOTA" formControlName="frmDescNota"
            [(ngModel)]="cabecalhoProtocolo.descricaoNota" value="{{cabecalhoProtocolo.descricaoNota}}">
          <mat-error *ngIf="f.frmDescNota.errors && f.frmDescNota.errors.required">Descrição da nota é
            obrigatório</mat-error>
        </mat-form-field>
        <mat-form-field fxFlex="45%">
          <input matInput placeholder="CÓDIGO DE BARRAS" formControlName="frmCodBarras"
            (change)="limparVencimento(); validarCodigoBarras()" [(ngModel)]="cabecalhoProtocolo.codigoBarras">
          <mat-error *ngIf="">Código de barras inválido</mat-error>
        </mat-form-field>
        <mat-form-field fxFlex="25%">
          <mat-select formControlName="frmResponsavel" placeholder="Responsável" [(value)]="responsavelSelected"
            required>
            <mat-option *ngFor="let responsavel of responsaveis" [value]="responsavel">
              {{responsavel.nome}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <mat-action-row class="footer">
        <button mat-button color="warn" (click)="prevStep()">Voltar</button>
        <button *ngIf="lstAdiantamentos != null && lstAdiantamentos.length > 0" mat-button color="warn"
          (click)="ListarAdiantamentos()">Visualizar Adiantamentos</button>
        <button mat-button color="primary" class="btn-primary" (keyup.enter)="onSubmitCabecalho()"
          (click)="onSubmitCabecalho()">CONTINUAR</button>
      </mat-action-row>
    </form>
  </mat-expansion-panel>

  <mat-expansion-panel *ngIf="fv60" class="expansion-panel" [disabled]="formulario3Disbled" [expanded]="step === 2"
    (opened)="setStep(2)">
    <mat-expansion-panel-header class="custom-header">

      <mat-panel-title>
        3. Rateio de Despesas
      </mat-panel-title>
    </mat-expansion-panel-header>

    <mat-progress-bar *ngIf="verifingColetor" class="progress-bar" mode="indeterminate"></mat-progress-bar>

    <form [formGroup]="rateioDespesasForm">
      <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
        <mat-form-field fxFlex="25%">
          <mat-select formControlName="frmTipoDespesa" [(value)]="tiposDespesaSelected" placeholder="Tipo de despesas"
            required>
            <mat-option *ngFor="let tpDespesa of tipoDespesas" [value]="tpDespesa">
              {{tpDespesa.codDespesa}} - {{tpDespesa.tipoDespesa}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="fRateio.frmTipoDespesa.errors && fRateio.frmTipoDespesa.errors.required">Um tipo de despesa
            deve ser selecionado</mat-error>

        </mat-form-field>
        <mat-form-field fxFlex="25%">
          <mat-select formControlName="frmTipoColetor" id="nomeTipoColetor" [(ngModel)]="rateioDespesas.codTipoColetor"
            placeholder="Tipo de coletor" (selectionChange)="VerificaDiagramaDeRede()">
            <mat-option value="N">N - Diagrama de rede</mat-option>
            <mat-option value="K">K - Centro de custo</mat-option>
            <mat-option value="F">F - Ordem Interna</mat-option>
            <mat-option value="A">A - Imobilizado</mat-option>
            <mat-option value="F">F - Ordem de Manutenção</mat-option>
          </mat-select>
          <mat-error *ngIf="fRateio.frmTipoColetor.errors && fRateio.frmTipoColetor.errors.required">Um tipo de coletor
            deve ser selecionado</mat-error>
        </mat-form-field>
        <mat-form-field fxFlex="23%">
          <input matInput formControlName="frmColetorCustos" [(ngModel)]="rateioDespesas.identificacaoColetor"
            value="{{rateioDespesas.identificacaoColetor}}" placeholder="Coletor de Custos">
          <mat-error *ngIf="fRateio.frmColetorCustos.errors && fRateio.frmColetorCustos.errors.required">Coletor de
            custos obrigatorio</mat-error>
            <mat-error *ngIf="rateioDespesasForm.get('frmColetorCustos').hasError('erroTipoRateioValidacao')">{{rateioDespesasForm.get('frmColetorCustos').errors.erroTipoRateioValidacao}}</mat-error>
        </mat-form-field>
        <div fxFlex="4%">
          <a class="linkPesquisa" mat-mini-fab (click)="PesquisarColetorCustos()" *ngIf="PesColetorCustos">
            <mat-icon class="iconPesquisa">search</mat-icon>
          </a>
        </div>
        <mat-form-field fxFlex="23%">
          <input matInput formControlName="frmNumOperacao" [(ngModel)]="rateioDespesas.operacaoSubNumero"
            placeholder="N. da operação">
          <mat-error
            *ngIf="fRateio.frmNumOperacao.hasError('maxlength') || diagramaDeRede">{{getErrorMessageNumOperacao()}}</mat-error>
        </mat-form-field>
      </div>
      <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
        <mat-form-field fxFlex="25%">
          <input matInput formControlName="frmValorDespesa" [(ngModel)]="rateioDespesas.valor" placeholder="Valor"
            class="example-right-align" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
          <mat-error *ngIf="fRateio.frmValorDespesa.errors && fRateio.frmValorDespesa.errors.required">É necessario um
            valor
          </mat-error>
        </mat-form-field>
        <mat-form-field fxFlex="65%">
          <input matInput formControlName="frmDescricaoDespesa" [(ngModel)]="rateioDespesas.descricao"
            value="{{rateioDespesas.descricao}}" placeholder="Descrição">
          <mat-error *ngIf="fRateio.frmDescricaoDespesa.errors && fRateio.frmDescricaoDespesa.errors.required">A
            descrição é obrigatório</mat-error>
        </mat-form-field>
        <div fxFlex="15%">
          <button mat-button color="primary" style="float: right;margin-top: 5px;" class="btn-primary"
            (click)="incluirRateio()">INCLUIR</button>
        </div>
      </div>

      <app-planilha></app-planilha>


      <br />
      <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
        <div style="padding: 0px !important;">
          <div>
            <mat-form-field>
              <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtrar">
            </mat-form-field>
          </div>
          <!--class="mat-elevation-z8"!-->
          <div class="table-container">
            <table mat-table [dataSource]="dataSource">
              <!-- tipoDespesa Column -->
              <ng-container matColumnDef="tipoDespesa">
                <th mat-header-cell *matHeaderCellDef> Tipo de despesas </th>
                <td mat-cell *matCellDef="let element"> {{element.nomeTipoDespesa}} </td>
              </ng-container>

              <!-- tipoColetor Column -->
              <ng-container matColumnDef="tipoColetor">
                <th mat-header-cell *matHeaderCellDef> Tipo de coletor </th>
                <td mat-cell *matCellDef="let element"> {{element.codTipoColetor}} </td>
              </ng-container>

              <!-- coletorCusto Column -->
              <ng-container matColumnDef="coletorCusto">
                <th mat-header-cell *matHeaderCellDef> Coletor de Custo </th>
                <td mat-cell *matCellDef="let element"> {{element.identificacaoColetor}} </td>
              </ng-container>

              <!-- numeroOperacao Column -->
              <ng-container matColumnDef="numeroOperacao">
                <th mat-header-cell *matHeaderCellDef> Nº da Operação </th>
                <td mat-cell *matCellDef="let element"> {{ element.operacaoSubNumero }}</td>
              </ng-container>

              <!-- descricao Column -->
              <ng-container matColumnDef="descricao">
                <th mat-header-cell *matHeaderCellDef> Descrição </th>
                <td mat-cell *matCellDef="let element"> {{element.descricao}} </td>
              </ng-container>

              <!-- valor Column -->
              <ng-container matColumnDef="valor">
                <th mat-header-cell *matHeaderCellDef> Valor </th>
                <td mat-cell *matCellDef="let element"> {{element.valor | currency:'BRL':true:'1.2-4'}} </td>
              </ng-container>

              <!-- Checkbox Column -->
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-icon class="calendar" (click)="deleteAllRows()">delete</mat-icon>
                </th>
                <td mat-cell *matCellDef="let row">
                  <mat-icon class="calendar" (click)="deleteRow(row)">delete</mat-icon>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div>
          <mat-paginator [pageSizeOptions]="[5, 50, 100, 500, 1000]" showFirstLastButtons></mat-paginator>
        </div>
      </div>
      <br />

      <div class="container container-input md-button-right" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
        <div fxFlex="70%" style="padding-right: 70px">
          <label class="align-rigth label colored-gray" style="width:250px !important;">A SEREM RATEADOS (R$):
            {{cabecalhoProtocolo.valor - somaRateio | currency:'BRL':true:'1.2-4'}}</label>
        </div>
        <div fxFlex="30%">
          <label style="font-weight: 500;" class="align-rigth colored-gray">TOTAL RATEADO (R$): {{somaRateio |
            currency:'BRL':true:'1.2-4'}}</label>
        </div>
      </div>

      <mat-action-row class="footer">
        <button mat-stroked-button *ngIf="modoEdicao" color="warn" class="cancel-button"
          (click)="CancelarProtocolo()">CANCELAR PROTOCOLO</button>
        <button (click)="rateioDespesasForm.reset()" class="visible-none" #resetButton type="reset">Reset</button>
        <button mat-button color="warn" (click)="prevStep()">Voltar</button>
        <button mat-button color="primary" class="btn-primary extra-large" (click)="Salvar()">SALVAR PROTOCOLO</button>
      </mat-action-row>
    </form>
  </mat-expansion-panel>

  <app-adiantamento *ngIf="Adiantamento"></app-adiantamento>

  <app-fundo-fixo *ngIf="Fundofixo"></app-fundo-fixo>
</mat-accordion>
